// extracted by mini-css-extract-plugin
module.exports = {"changeText":"acc_wr","optionWrapper":"acc_ace","arrowWrapper":"acc_acf","arrow":"acc_qk","arrow_down":"acc_acg acc_qk","arrow_up":"acc_ach acc_qk","active":"acc_pi"};